module.exports = "../images/lake.jpg?v=b8c76a7";